import { useEffect, useMemo } from "react";
import { selectAuthUser, testPlugin } from "@/redux/reducers/auth.reducer";
import { useAppDispatch, useAppSelector } from "@/redux/rootReducer";
import PluginCard from "../components/PluginCard";

function PluginCardContainer() {

    const dispatch = useAppDispatch();
    const authUser = useAppSelector(selectAuthUser);

    useEffect(() => {
        dispatch(testPlugin());
    }, [dispatch])

    const isPluginAvailable = useMemo(() => {
        if (!authUser) return false
        // TODO: replace by pluginId
        // if(!authUser.plugins) return false
        // for (const plugin of authUser.plugins) {
        //     if(plugin.name.includes("netsoin")){
        //         return true
        //     }
        // }
        return true
    }, [authUser])


    return (
        <PluginCard available={isPluginAvailable} />
    )
}

export default PluginCardContainer